import React, { useState } from 'react';
import { REACT_APP_API_NOTIFICATIONS } from '../../../utils/constants';

const NotificationItem = (nofitication) => {
  const [isRead, setIsRead] = useState(nofitication.is_read);

  const handleReadMessage = async (notificationId) => {
    setIsRead(true);
    const options = {
      method: 'PUT',
      body: JSON.stringify({
        id: notificationId
      })
    };
    const response = await fetch(REACT_APP_API_NOTIFICATIONS, options);
    if (response.status === 200) {
      console.log('DONE');
    }
  };

  return (
    <div className="card mg-b-20 mg-lg-b-25">
      <div className="card-header pd-y-15 pd-x-20 flex items-center justify-between">
        <h6 className="tx-uppercase tx-semibold mg-b-0">{nofitication.type}</h6>
      </div>
      <div className="card-body pd-20 pd-lg-25">
        <h6 className="tx-15 mg-b-3">{nofitication.title}</h6>
        <div className="bd bg-gray-50 pd-y-15 pd-x-15 pd-sm-x-20">
          <p className="mg-b-0 tx-14">{nofitication.text}</p>
          <span className="tx-13 tx-color-03">{nofitication.createdAt}</span>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
